export default __webpack_public_path__ + "static/footerLogo-b4f216b75a481e6cefffd343d6476eac.svg";